<template>
  <pie-chart :chart-data="chartData"/>
</template>

<script>
  import PieChart from "@view/components/chart/PieChart"
  export default {
    name: "DeviceType",
    components: {PieChart},
    data() {
      return {
        chartData: {
          title: "设备型号",
          roseType: false,
          radius: [0, 95],
          data: []
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        let res = await this.$Http.getDeviceModel();
        if (res) {
          let list = res.data || [];
          this.chartData.data = list.map(item => {return {name: item.model, value: item.count}});
        }
      }
    }
  }
</script>

<style scoped>

</style>
